<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'goods-in-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import { PurchaseOrder } from "../../_services/api/purchasing/purchase-order.service";
import { FeatureStorage } from "../../_services/storage";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Purchase Orders",
        ScreenName: "Purchase Orders - To Receive",
        selectedIndex: 1,
        tabs: [
          {
            text: "All",
            path: `/purchase-order`,
            applicationFeatureCode: "PurchaseOrder",
          },
          {
            text: "To Receive",
            path: `/goods-in`,
            applicationFeatureCode: "GoodsIn",
          },
          {
            text: "Received",
            path: `/goods-in-review`,
            applicationFeatureCode: "GoodsIn",
          },
          // {
          //   text: "To Return",
          //   path: `/goods-return`,
          //   applicationFeatureCode: "GoodsReturn",
          // },
          {
            text: "Invoiced",
            path: `/supplier-invoiced`,
            applicationFeatureCode: "SupplierInvoice",
          },
        ],

        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "PurchaseOrderList",
              // select: [
              //   "Code",
              //   "SupplierCode",
              //   "Status",
              //   "FriendlyStatus",
              //   "SupplierName",
              //   "DateIn",
              //   "DateReceived",
              // ],
              filter: [["Status", "=", "A"]],
              serverPaging: true,
              allowGrouping: false,
            },
            // rowSelect: {
            //   view: this,
            //   page: "purchase-order",
            //   mode: "review",
            //   idProperty: "Code",
            // },
            noDataMessage: {
              addNew: {
                class: "hooray",
                title: "No Purchase Orders",
                message:
                  "Your work is complete, all orders have been received.",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            // customButtons: [
            //   {
            //     icon: "plus",
            //     label: "Add New",
            //     route: "/purchase-order/create",
            //     clickAction: {},
            //     buttonLocation: "left",
            //   },
            // ],
          },
          columns: [
            {
              screenField: "PurchaseOrder",
              gridDataField: "Code",
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              width: ColumnWidth.PurchaseOrderCode.width,
              minWidth: ColumnWidth.PurchaseOrderCode.minWidth,
              forceWidth: true,
              hyperlink: {
                url: "purchase-order-v2/review/__ID__",
                target: "_blank",
              },
            },
            {
              screenField: "Code",
              filterLabel: "Purchase Order",
              showInColumnChooser: false,
              visible: false,
              type: "Integer",
              filterIndex: 0,
            },
            {
              screenField: "Supplier",
              gridDataField: "SupplierCode",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SupplierName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SupplierCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "SupplierCode",
                  label: "Supplier Code",
                },
                {
                  dataField: "SupplierName",
                  label: "Supplier Name",
                },
              ],
              filterDataField: "SupplierCode",
              filterIndex: 1,
            },
            {
              screenField: "SupplierRef",
              dataType: "string",
              type: "Text",
              filterIndex: 2,
              width: ColumnWidth.SupplierRef.width,
              minWidth: ColumnWidth.SupplierRef.minWidth,
            },
            {
              screenField: "DateIn",
              gridLabel: "Date",
              filterLabel: "Date",
              filterIndex: 3,
            },
            {
              screenField: "LineComment",
              gridLabel: "# Lines",
              dataField: "LineInfo",
              width: ColumnWidth.LineInfo.width,
              minWidth: ColumnWidth.LineInfo.minWidth,
            },
            {
              screenField: "ETADate",
              gridLabel: "ETA Date",
              filterLabel: "ETA Date",
              filterIndex: 4,
            },
            {
              screenField: "DateReceived",
              gridLabel: "Date Received",
              filterLabel: "Date Received",
              filterIndex: 5,
            },
            {
              screenField: "ProductAcct",
              visible: false,
              filterIndex: 6,
              filterOperator: "contains",
              gridDataField: "ItemCodeList",
              filterDataField: "ItemCodeList",
              showInColumnChooser: false,
            },
            {
              screenField: "OrderStatus",
              gridDataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              width: 120,
              filterIndex: 7,
              dataSourceConfig: {
                data: ["Awaiting Receipt", "Partially Received"],
              },
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Complete Order",
                      data: data,
                      clickAction: this.completeOrder,
                      visible: data.data.GoodsReceived == "Y" ? true : false,
                    },
                    {
                      menuText: "Cancel Order",
                      data: data,
                      clickAction: this.cancelOrder,
                      visible: data.data.GoodsReceived == "N" ? true : false,
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: (data) => {
                if (
                  !FeatureStorage.checkPermission("PurchaseOrder", "create") ||
                  data.data.Status == "C" ||
                  data.data.Status == "X"
                )
                  return true;
                else return false;
              },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "OrderStatus" &&
        e.column.screenField != "GridRecordEmail" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordPrint" &&
        e.column.screenField != "GridRecordEllipsisMenu" &&
        e.column.screenField != "PurchaseOrder"
      ) {
        if (this.formsConfig.editableOption) {
          this.onRowClicked(e, {
            view: this,
            page: "goods-in",
            mode: "edit",
            idProperty: "Code",
          });
        } else {
          this.onRowClicked(e, {
            view: this,
            page: "goods-in",
            mode: "review",
            idProperty: "Code",
          });
        }
      }
    },
    async completeOrder(e, grid) {
      let confirmcompletel = await this.$confirm(
        "Do you want to complete this order?",
        "Complete Order"
      );

      if (confirmcompletel) {
        this.setLoading = true;
        await PurchaseOrder.completeOrder({ Code: e.Code })
          .then((res) => {
            if (res) this.setLoading = false;
            grid.refresh(true);
          })
          .catch((err) => {
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Complete Complete Failed",
            });
          });
      }
    },
    async cancelOrder(e, grid) {
      let confirmCancel = await this.$confirm(
        "Do you want to cancel this order?",
        "Cancel Order"
      );

      if (confirmCancel) {
        this.setLoading = true;
        const payload = {
          Code: e.Code,
          DateChanged: e.DateChanged,
        };

        await PurchaseOrder.cancelOrder(payload)
          .then((res) => {
            if (res) this.setLoading = false;
            grid.refresh(true);
          })
          .catch((err) => {
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Complete Cancel Failed",
            });
          });
      }
    },
  },

  created() {},
};
</script>

<style lang="scss"></style>
